import React from 'react';
import PropTypes from 'prop-types';
import StripeCheckout from 'react-stripe-checkout';

import config from '../../../config';
import analytics from '../../applicationServices/analytics/BookingAnalytics';

const CheckoutButton = ({
  onSuccess,
  currency,
  amount,
  disabled,
  email,
  className,
  panelLabel,
  children,
}) => {
  let submitted = false;

  return (
    <StripeCheckout
      token={(...args) => { submitted = true; return onSuccess(...args); }}
      currency={currency.toUpperCase()}
      amount={amount}
      stripeKey={config.stripeKey}
      name="SQUIRE"
      description="Squire Technologies is a company dedicated to making style and grooming simple for men."
      panelLabel={panelLabel}
      email={email}
      disabled={disabled}
      opened={() => analytics.startPayment({ source: 'stripe_modal' })}
      closed={() => !submitted && analytics.abandonPayment({ source: 'stripe_modal' })}
    >
      <button
        className={className}
        type="button"
        disabled={disabled}
      >
        {children}
      </button>
    </StripeCheckout>
  );
};

CheckoutButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  email: PropTypes.string,
  className: PropTypes.string,
  panelLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
};

CheckoutButton.defaultProps = {
  email: '',
  className: '',
  panelLabel: null,
};

export default CheckoutButton;



// WEBPACK FOOTER //
// ./src/app/reservation/components/StripeCheckoutButton.jsx